import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { tap, concatMap, finalize } from "rxjs/operators";

/**
 * Service to manage loading state throughout the application
 */
@Injectable({
    providedIn: "root",
})
export class LoadingService {
    private loadingSubject = new BehaviorSubject<boolean>(false);
    public loading$: Observable<boolean> = this.loadingSubject.asObservable();

    /**
     * Shows loader until the provided observable completes
     * @param obs$ The observable to monitor
     * @returns The same observable with loading state handling
     */
    public showLoaderUntilCompleted<T>(obs$: Observable<T>): Observable<T> {
        return of(null).pipe(
            tap(() => this.loadingOn()),
            concatMap(() => obs$),
            finalize(() => this.loadingOff()),
        );
    }

    /**
     * Activates the loading state
     * @param showSpinner Optional flag to show a spinner
     */
    public loadingOn(showSpinner: boolean = false): void {
        // Spinner implementation can be added here if needed
        this.loadingSubject.next(true);
    }

    /**
     * Deactivates the loading state
     * @param hideSpinner Optional flag to hide a spinner
     */
    public loadingOff(hideSpinner: boolean = false): void {
        // Spinner implementation can be added here if needed
        this.loadingSubject.next(false);
    }
}
